import React from 'react';

const SvgElectro: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path fill="#5A636B" d="M12.75 6.5 7.675 15V9.5H4L9.25 1v5.5h3.5Z" />
  </svg>
);

export default SvgElectro;
